import type { Dict } from './en';
import { pushPl } from './push-strings';

export const pl = {
  ...pushPl,

  'app.name': 'Dialano',

  'threads.title': 'Rozmowy',
  'threads.empty.title': 'Nie ma jeszcze żadnych firm',
  'threads.empty.body': 'Dodaj firmę po numerze telefonu i zacznij rozmawiać.',
  'threads.add': 'Dodaj firmę',
  'threads.you': 'Ty: ',
  'threads.pending': 'wysyłanie…',
  'threads.readOnly': 'tylko do odczytu',
  'threads.paused': 'wstrzymane',

  'add.title': 'Dodaj firmę',
  'add.numberLabel': 'Numer telefonu firmy',
  'add.numberHint': 'Format międzynarodowy, np. +48 600 100 200',
  'add.error.own_as_company': 'To Twój numer — wpisz tu numer firmy.',

  'onboarding.title': 'Twój numer telefonu',
  'onboarding.body':
    'Na ten numer firmy będą wysyłać SMS-y z kodami weryfikacyjnymi. Podajesz go raz; później można go zmienić w Ustawieniach.',
  'onboarding.continue': 'Dalej',
  'settings.ownNumber': 'Twój numer telefonu',
  'settings.ownNumber.saved': 'Zapisano',
  'add.continue': 'Dalej',
  'add.progress.looking_up': 'Szukam numeru…',
  'add.progress.registering_device': 'Przygotowuję to urządzenie…',
  'add.progress.verifying_code': 'Sprawdzam kod…',
  'add.codeTitle': 'Wpisz kod wysłany na {phone}',
  'add.codeHint': 'Firma wysłała Ci SMS z 6-cyfrowym kodem.',
  'add.verify': 'Zweryfikuj',
  'add.done': 'Firma dodana',
  'add.reducedTrust':
    'Nie udało się odświeżyć katalogu firm, więc dodawanie nowych firm jest wstrzymane. Istniejące rozmowy działają dalej.',
  'add.error.bad_request': 'To nie wygląda na poprawny numer w formacie międzynarodowym.',
  'add.error.not_found': 'Pod tym numerem nie ma zarejestrowanej firmy.',
  'add.error.entry_withdrawn': 'Ta firma nie przyjmuje już nowych rozmów.',
  'add.error.number_not_allowed': 'Tego numeru nie można tu użyć.',
  'add.error.rate_limited': 'Za dużo prób. Spróbuj za chwilę.',
  'add.error.invalid_code': 'Ten kod się nie zgadza. Sprawdź go i spróbuj ponownie.',
  'add.error.code_expired': 'Ten kod wygasł. Zacznij od nowa, żeby dostać nowy.',
  'add.error.no_network': 'Brak połączenia. Sprawdź internet i spróbuj ponownie.',
  'add.error.clock_unreliable':
    'Zegar urządzenia wygląda na przestawiony, więc danym katalogu nie można ufać. Ustaw zegar i spróbuj ponownie.',
  'add.error.generic': 'Coś poszło nie tak. Spróbuj ponownie.',

  'add.contacts.title': 'Firmy z kontaktów w telefonie',
  'add.contacts.body':
    'Wybierz kontakty, a sprawdzę, które z ich numerów należą do firm dostępnych tutaj. Sprawdzenie odbywa się na tym urządzeniu — numery nie są nigdzie wysyłane.',
  'add.contacts.pick': 'Wybierz kontakty do sprawdzenia',
  'add.contacts.checking': 'Sprawdzam…',
  'add.contacts.none': 'Żaden z wybranych numerów nie należy do firmy dostępnej tutaj.',
  'add.contacts.error': 'Nie udało się otworzyć wyboru kontaktów. Numer zawsze możesz wpisać ręcznie.',

  'conv.composerHint': 'Wiadomość',
  'conv.send': 'Wyślij',
  'conv.linkBlocked': 'Nie można tu wysyłać linków.',
  'conv.pending': 'Czeka na wysłanie',
  'conv.failed': 'Nie wysłano',
  'conv.retry': 'Ponów',
  'conv.discard': 'Odrzuć',
  'conv.personAnswering': 'Odpowiada człowiek',
  'conv.readOnlyBanner': 'Ta firma zamknęła swój kanał. Rozmowa jest tylko do odczytu.',
  'conv.pausedBanner':
    'Klucz serwera firmy się zmienił. Wysyłanie jest wstrzymane, dopóki nie przejrzysz tego w ustawieniach firmy.',
  'conv.quarantineBanner': 'Okres oczekiwania nowego urządzenia — starsza historia może dotrzeć później.',
  'conv.reverifyBanner': 'Ten numer trzeba ponownie zweryfikować u tej firmy.',
  'conv.reverify': 'Zweryfikuj ponownie',
  'conv.attachPhoto': 'Dołącz zdjęcie',
  'conv.recordVoice': 'Nagraj wiadomość głosową',
  'conv.recording': 'Nagrywanie… {s} s',
  'conv.recordingStop': 'Zatrzymaj i wyślij',
  'conv.recordingCancel': 'Anuluj',
  'conv.micDenied': 'Brak dostępu do mikrofonu, więc nie można nagrywać wiadomości głosowych.',

  'el.unknown': 'Do wyświetlenia tej treści potrzebna jest nowsza wersja aplikacji.',
  'el.voice.unplayable': 'Tego nagrania nie da się odtworzyć na tym urządzeniu.',
  'el.voice.download': 'Pobierz nagranie',
  'el.image.open': 'Otwórz obraz',
  'el.question.answerHint': 'Twoja odpowiedź',
  'el.question.required': 'To pytanie wymaga odpowiedzi.',
  'el.cart.total': 'Razem',
  'el.cart.accept': 'Akceptuję',
  'el.cart.adjust': 'Wyślij zmiany',
  'el.cart.decline': 'Odrzucam',
  'el.cart.note': 'Notatka (opcjonalnie)',
  'el.cart.state.proposed': 'Czeka na Twoją decyzję',
  'el.cart.state.accepted': 'Zaakceptowany',
  'el.cart.state.declined': 'Odrzucony',
  'el.cart.state.amended': 'Zmiany wysłane',
  'el.cart.state.superseded': 'Zastąpiony nowszym koszykiem',
  'el.cart.conflict': 'Ten koszyk zmienił się po stronie firmy. Zobacz najnowszą wersję.',
  'el.order.state.received': 'Przyjęte',
  'el.order.state.processing': 'W przygotowaniu',
  'el.order.state.shipped': 'Wysłane',
  'el.order.state.delivered': 'Dostarczone',
  'el.order.state.cancelled': 'Anulowane',
  'el.order.expected': 'Przewidywana dostawa: {date}',
  'el.order.reference': 'Numer: {ref}',
  'el.payment.info': 'Ta aplikacja nie obsługuje płatności.',
  'el.location.copy': 'Skopiuj współrzędne',
  'el.location.copied': 'Skopiowano',
  'el.calendar.title': 'Termin',
  'el.calendar.cancelled': 'Odwołany',
  'el.calendar.download': 'Dodaj do kalendarza (.ics)',
  'el.video.download': 'Pobierz wideo',

  'contact.title': 'Firma',
  'contact.number': 'Numer telefonu',
  'contact.server': 'Adres serwera',
  'contact.notifications': 'Kategorie powiadomień',
  'contact.muted': 'Wyciszone',
  'contact.orders': 'Zamówienia',
  'contact.export': 'Pobierz historię',
  'contact.delete': 'Usuń firmę',
  'contact.delete.confirm':
    'Usunąć tę firmę? Rozmowa i jej historia znikną z tego urządzenia.',
  'contact.keyChange.title': 'Klucz serwera się zmienił',
  'contact.keyChange.body':
    'Serwer firmy przedstawia się innym kluczem niż dotąd. To może być zwykła przeprowadzka serwera — albo ktoś się pod niego podszywa. Wysyłanie pozostaje wstrzymane, dopóki nie zaakceptujesz nowego klucza.',
  'contact.keyChange.trust': 'Zaufaj nowemu kluczowi',
  'contact.moved.signed': 'Ta firma się przeniosła. Rozmowa podąża za nią automatycznie.',
  'contact.moved.waiting': 'Ta firma zgłasza przenosiny. Wysyłanie jest wstrzymane na czas oczekiwania.',
  'contact.withdrawn': 'Ta firma zamknęła swój kanał. Historia zostaje na tym urządzeniu.',

  'orders.title': 'Zamówienia',
  'el.request.title': 'Zapytanie o:',
  // ——— powierzchnia dla personelu (opcjonalna, nie dla kupującego) ———
  'staff.title': 'Konto służbowe',
  'staff.server': 'Adres serwera firmy',
  'staff.login': 'Login',
  'staff.password': 'Hasło',
  'staff.signIn': 'Zaloguj',
  'staff.signOut': 'Wyloguj',
  'staff.buyers': 'Kupujący',
  'staff.noBuyers': 'Na tym serwerze nie ma jeszcze żadnych rozmów.',
  'staff.pages': 'Strony',
  'staff.published': 'Opublikowane: {n} z 6',
  'staff.live': 'na żywo',
  'staff.draft': 'szkic',
  'staff.edit': 'Edytuj',
  'staff.publish': 'Opublikuj',
  'staff.remove': 'Usuń',
  'staff.newPage': 'Nowa strona',
  'staff.pageTitle': 'Etykieta w menu',
  'staff.elements': 'Elementy',
  'staff.save': 'Zapisz szkic',
  'staff.preview': 'Co zobaczy kupujący',
  'staff.jsonArray': 'Elementy muszą być tablicą JSON.',
  'staff.slotHint':
    'Kartka stawia kontrolkę przez <ctl i="0">, wypełnianą pozycją 0 z listy controls. Napis na przycisku pisze aplikacja, nie Ty.',
  // ——— strony firmy ———
  'views.fromSupplier': 'Od tego dostawcy',
  'views.loading': 'Otwieram…',
  'views.offline': 'Pokazane z tego urządzenia. Brak połączenia, więc nic tu teraz nie zamówisz.',
  'views.goneTitle': 'Strona niedostępna',
  'views.goneBody': 'Ta firma już nie udostępnia tej strony.',
  'views.control.quantity': 'Ilość',
  'views.control.requestItems': 'Zapytaj o te pozycje',
  'views.control.cartAccept': 'Zamawiam',
  'views.control.cartAmend': 'Zmień ilości',
  'views.control.cartDecline': 'Rezygnuję',
  'views.control.answer': 'Odpowiedz',
  'views.control.calendarAdd': 'Dodaj do kalendarza',
  'views.control.itemQuantity': 'Ilość: {name}',
  'views.requestSent': 'Zapytanie o pozycje: {count}.',

  'orders.empty': 'W tej rozmowie nie ma jeszcze zamówień.',

  'settings.title': 'Ustawienia',
  'settings.language': 'Język',
  'settings.language.system': 'Systemowy',
  'settings.language.en': 'English',
  'settings.language.pl': 'Polski',
  'settings.diagnostics': 'Diagnostyka',
  'settings.about': 'Dialano — rozmowy z firmami: pytaj, zamawiaj, umawiaj się.',
  'settings.push.title': 'Powiadomienia',
  'settings.push.body':
    'Firmy mogą powiadamiać Cię o nowych wiadomościach. Powiadomienie może zawierać treść wiadomości, zaszyfrowaną tak, że odczyta ją tylko to urządzenie — usługa budząca przekazuje ją dalej, nie mogąc zajrzeć do środka.',
  'settings.push.enable': 'Włącz powiadomienia',
  'settings.push.on': 'Powiadomienia włączone',
  'settings.push.off': 'Wyłącz',
  'settings.push.denied': 'Powiadomienia są zablokowane w ustawieniach przeglądarki.',
  'settings.push.unsupported': 'Ta przeglądarka nie obsługuje powiadomień dla zainstalowanych aplikacji.',
  'push.nudge.body': 'Włącz powiadomienia — odpowiedzi dotrą do Ciebie nawet przy zamkniętej aplikacji.',
  'push.nudge.enable': 'Włącz',
  'push.nudge.retry': 'Spróbuj ponownie',
  'push.fail.dismissed': 'Okienko zgody zostało zamknięte — tapnij ponownie i zezwól na powiadomienia.',
  'push.fail.noGatewayKey':
    'Katalog nie ma jeszcze klucza bramy budzenia. Sprawdź połączenie i spróbuj za chwilę.',
  'push.fail.subscribe': 'Przeglądarka odrzuciła subskrypcję. Spróbuj ponownie za chwilę.',
  'push.fail.notReady': 'Aplikacja jeszcze się instaluje w tle — odczekaj chwilę i spróbuj ponownie.',

  'diag.title': 'Diagnostyka',
  'diag.directory': 'Katalog',
  'diag.manifestVersion': 'Wersja manifestu',
  'diag.fetchedAt': 'Pobrano',
  'diag.fromDomain': 'Z domeny',
  'diag.validUntil': 'Ważny do',
  'diag.entries': 'Wpisy w pamięci',
  'diag.lastError': 'Ostatni błąd',
  'diag.push': 'Powiadomienia',
  'diag.push.supported': 'Wspierane tutaj',
  'diag.push.permission': 'Zgoda systemowa',
  'diag.push.subscribed': 'Subskrypcja istnieje',
  'diag.push.vapid': 'Klucz bramy w katalogu',
  'diag.yes': 'tak',
  'diag.no': 'nie',
  'diag.offline': 'Kopia offline',
  'diag.offline.registered': 'Zapisana na tym urządzeniu',
  'diag.offline.controlling': 'Obsługuje tę stronę',
  'diag.offline.state': 'Stan',
  'diag.offline.files': 'Zapisane pliki',
  'diag.offline.startPage': 'Strona startowa zapisana',
  'diag.offline.servedLaunch': 'Obsłużyła to uruchomienie',
  'diag.offline.note':
    'Otwarcie bez połączenia wymaga „tak" przy „Obsługuje tę stronę". Przy „Obsłużyła to uruchomienie" zwykle jest „nie" na tym uruchomieniu, które zapisało kopię. Naprawa pobiera kopię od nowa i nie rusza Twoich wiadomości.',
  'diag.offline.repair': 'Napraw kopię offline',
  'diag.storage': 'Pamięć',
  'diag.persisted': 'Chroniona przed wyczyszczeniem',
  'diag.persisted.yes': 'tak',
  'diag.persisted.no': 'nie — przeglądarka może wyczyścić dane przy braku miejsca',
  'diag.estimate': 'Zajęte {used} z {quota}',
  'diag.recovery':
    'Jeśli to urządzenie straci dane, zweryfikuj numer ponownie u każdej firmy — historia wróci z ich serwerów.',
  'diag.boot': 'To uruchomienie',
  'diag.boot.sw': 'Start service workera',
  'diag.boot.ttfb': 'Pierwszy bajt',
  'diag.boot.entry': 'Skrypt wejściowy działa',
  'diag.boot.settings': 'Odczyt ustawień',
  'diag.boot.mounted': 'Pierwszy ekran narysowany',
  'diag.boot.note':
    'Czasy od początku uruchomienia. Zamknij aplikację całkowicie i otwórz ponownie, żeby zmierzyć zimny start — ciepły niewiele mówi.',

  'diag.contacts': 'Firmy',
  'diag.cursor': 'Kursor',
  'diag.lastSequence': 'Ostatnia sekwencja',
  'diag.gap': 'Wykryto lukę w strumieniu zdarzeń',
  'diag.resync': 'Zsynchronizuj od początku',
  'diag.syncError': 'Ostatni błąd synchronizacji',

  'author.agent': 'asystent',
  'author.human': 'człowiek',
  'author.system': 'system',

  'common.menu': 'Menu',
  'common.back': 'Wstecz',
  'common.save': 'Zapisz',
  'common.cancel': 'Anuluj',
  'common.close': 'Zamknij',
  'common.delete': 'Usuń',
  'common.retry': 'Ponów',
  'common.updated': 'Dialano zaktualizowano.',
  'common.reload': 'Odśwież',
} satisfies Dict;
